import { TabList } from '@mui/lab';
import { Box, styled, Tab } from '@mui/material';

export const StyledTabList = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main,
  },
  '& .MuiTab-root.Mui-selected': {
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
  },
}));

export const TabContainer = styled(Box)(() => ({
  padding: '40px 0',
}));

export const TabStyled = styled(Tab)(({ theme }) => ({
  textTransform: 'capitalize',
  fontSize: 16,
  fontWeight: 400,
  color: '#707070',

  [theme.breakpoints.down('xl')]: {
    fontSize: '14px',
  },
}));
